import { render, staticRenderFns } from "./ButtonCheckbox.vue?vue&type=template&id=04c1dce6&scoped=true"
import script from "./ButtonCheckbox.vue?vue&type=script&lang=js"
export * from "./ButtonCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ButtonCheckbox.vue?vue&type=style&index=0&id=04c1dce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1dce6",
  null
  
)

export default component.exports